import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import UserPanelInfo from '../Complements/UserPanelInfo';
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
}));
const TaxeRenderBody = props => {
    const { user, balances, accountSelected, changeAccount, children } = props
    const classes = useStyles();
    return (
        <Grid container className={classes.root}  justify="center" alignItems="center">
            <Grid item xs={12}>
                <Grid container  spacing={5} >
                    <UserPanelInfo
                        user = { user }
                        balances = { balances }
                        accountSelected = {accountSelected}
                        changeAccount = {changeAccount} />
                    { children }
                </Grid>
            </Grid>
        </Grid>
    );
};

TaxeRenderBody.propTypes = {
    user: PropTypes.object.isRequired,
    balances: PropTypes.array.isRequired,
    accountSelected: PropTypes.object.isRequired,
    changeAccount: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default TaxeRenderBody;